module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/media-management/view"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Upload / Update Media Management")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOrUpdateMedia.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "media_name"
    }
  }, [_vm._v("Media Name (internal)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.media_name),
      expression: "gRowObj.media_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.media_name.required
    },
    attrs: {
      "type": "text",
      "id": "media_name",
      "placeholder": "Media Name",
      "disabled": _vm.isEdit
    },
    domProps: {
      "value": (_vm.gRowObj.media_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "media_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.media_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter media name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "media_type"
    }
  }, [_vm._v("Media Type")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose a type--",
      "multiple": false,
      "options": _vm.mediaTypeList
    },
    on: {
      "select": _vm.typeChange
    },
    model: {
      value: (_vm.gRowObj.media_type),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "media_type", $$v)
      },
      expression: "gRowObj.media_type"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "country_name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    on: {
      "change": function($event) {
        return _vm.getLanguagesInCountry()
      }
    },
    model: {
      value: (_vm.mediaSet.country),
      callback: function($$v) {
        _vm.$set(_vm.mediaSet, "country", $$v)
      },
      expression: "mediaSet.country"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "selected": data.country_id === _vm.mediaSet.country,
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Languages")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "placeholder": "--Choose multiple languages--",
      "multiple": true,
      "options": _vm.languages
    },
    model: {
      value: (_vm.mediaSet.langs),
      callback: function($$v) {
        _vm.$set(_vm.mediaSet, "langs", $$v)
      },
      expression: "mediaSet.langs"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-6 col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "fileUpload"
    }
  }, [_vm._v("Upload file:")]), _vm._v(" "), _c('div', [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "fileUpload",
      "accept": _vm.acceptTypes,
      "disabled": !_vm.gRowObj.media_type
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "disabled": !_vm.gRowObj.media_type
    },
    on: {
      "click": _vm.triggerFileSelect
    }
  }, [_vm._v("Choose File")]), _vm._v(" "), (_vm.selectedFile) ? _c('p', {
    on: {
      "click": _vm.triggerFileSelect
    }
  }, [_vm._v("Selected file name: " + _vm._s(_vm.selectedFile.name))]) : _vm._e(), _vm._v(" "), (_vm.gRowObj.media_type && _vm.gRowObj.media_type.includes('audio')) ? _c('div', {
    staticClass: "text-red text-bold"
  }, [_vm._v("WARNING: Ensure the audio sample rate is 44.1kHz or lower by checking the file properties.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-1 col-md-1 col-lg-1"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.addMediaMapping()
      }
    }
  })])])]), _vm._v(" "), (Object.keys(_vm.medias).length) ? _c('table', {
    staticClass: "table table-striped margin-top-20"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.medias), function(value, key) {
    return _c('tbody', {
      key: key
    }, _vm._l((value), function(mediaRow, langs, iSub) {
      return _c('tr', {
        key: langs
      }, [(iSub === 0) ? _c('td', {
        staticStyle: {
          "width": "15%",
          "background-color": "#e8e8e8"
        },
        attrs: {
          "rowspan": Object.keys(value).length
        }
      }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getFormattedCountry(key)))])])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "15%",
          "background-color": "#f3f2f2"
        }
      }, [_c('strong', [_c('h4', [_vm._v(_vm._s(_vm.getFormattedLanguages(langs, key)))])])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "50%"
        }
      }, [_vm._v("\n                                    " + _vm._s(mediaRow.name) + "\n                                    "), _vm._v(" "), (_vm.isEdit && _vm.gRowObj.id && mediaRow.s3_key && !mediaRow.media) ? _c('media-preview', {
        attrs: {
          "compact": "",
          "show-caption": false,
          "format": _vm.gRowObj.media_type || 'document',
          "media-id": _vm.gRowObj.id,
          "country-id": key,
          "language-id": String(langs).split(',')[0],
          "missing-text": ": no stored file"
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_c('i', {
        staticClass: "fa fa fa-pencil",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            return _vm.editMediaMapping(langs, key)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle",
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            return _vm.deleteMediaMapping(langs, key)
          }
        }
      })])])
    }), 0)
  })], 2) : _vm._e()])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Media Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Media Upload Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "width-100"
  }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
    staticClass: "width-100"
  }, [_vm._v("Languages")]), _vm._v(" "), _c('th', [_vm._v("Media File")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "note-text-media"
  }, [_vm._v("Note: You need to re-upload the media every 90 days as per Meta's guidelines. Learn more about\n                        "), _c('a', {
    attrs: {
      "href": "https://whatsapp.turn.io/docs/api/media",
      "target": "_blank"
    }
  }, [_vm._v("WhatsApp")]), _vm._v(" and\n                        "), _c('a', {
    attrs: {
      "href": "https://developers.facebook.com/docs/messenger-platform/reference/attachment-upload-api",
      "target": "_blank"
    }
  }, [_vm._v("Messenger")]), _vm._v(" API limitations.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1665e9d1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/media-management/createOrUpdateMedia.vue
// module id = MSsd
// module chunks = 1